import { render, staticRenderFns } from "./upgrades.vue?vue&type=template&id=0e58fcaf&"
import script from "./upgrades.vue?vue&type=script&lang=ts&"
export * from "./upgrades.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports